Apt.fn.extend('account-post', {}, {
	/**
	 * Bind actions for the detail step
	 */
	detailSetup() {
		const scope = this;

		if (! scope.syndicated) {
			scope.initDescription();
			scope.initParcels();
			scope.initTaxes();
			scope.initExpenses();
			scope.initSchools();
			scope.initOpenHouses();
			scope.initFinancing();
			scope.initPhone();
		}

		scope.initUtilities();
	},

	/**
	 * Initialize structure
	 */
	initDescription() {
		const scope = this;

		LS.util.load('edit', () => {
			scope.editor = Apt.fn.edit()
				.init('$postDescriptionInput');
		});
	},

	/**
	 * Initialize parcels
	 */
	initParcels() {
		const key = 'data.parcels';

		$.events.on({
			'$addParcel': {
				click: () => {
					$.app.post.$push(key, {
						parcel_number: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteParcel': {
				click: (e, el) => {
					$.app.post.$drop(key + '.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize taxes
	 */
	initTaxes() {
		const key = 'data.taxes';

		$.events.on({
			'$addTax': {
				click: () => {
					$.app.post.$push(key, {
						year: new Date().getFullYear(),
						amount: '',
						description: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteTax': {
				click: (e, el) => {
					$.app.post.$drop(key + '.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize expenses
	 */
	initExpenses() {
		const key = 'data.expenses';

		$.events.on({
			'$addExpense': {
				click: () => {
					$.app.post.$push(key, {
						type: '',
						amount: '',
						period: '',
						description: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteExpense': {
				click: (e, el) => {
					$.app.post.$drop(key + '.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize utilities
	 */
	initUtilities() {
		const key = 'data.utilities';

		$.events.on({
			'$addUtility': {
				click: () => {
					$.app.post.$push(key, {
						category: '',
						utility_id: '',
						status: '',
						description: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteUtility': {
				click: (e, el) => {
					$.app.post.$drop(key + '.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize schools
	 */
	initSchools() {
		$.events.on({
			'$addSchool': {
				click: () => {
					$.app.post.$push('data.schools', {
						name: '',
						level: '',
						type: '',
						district: $.app.post.$get('data.school_district'),
						description: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteSchool': {
				click: (e, el) => {
					$.app.post.$drop('data.schools.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize open houses
	 */
	initOpenHouses() {
		$.events.on({
			'$addOpenHouse': {
				click: () => {
					$.app.post.$push('data.open_houses', {
						begins: '',
						ends: '',
						description: '',
						appointment: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteOpenHouse': {
				click: (e, el) => {
					$.app.post.$drop('data.open_houses.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize financing
	 */
	initFinancing() {
		const scope = this;

		$.events.on({
			'$addFinanceTerm': {
				click: () => {
					$.app.post.$push('data.financing.terms', {
						uid: LS.util.uid(),
						down: 0,
						down_type: 'percent',
						rate: 8,
						term: 60,
						payment: scope.calculatePayment
					});
				}
			},
			'$deleteFinanceTerm': {
				click: (e, el) => {
					$.app.post.$drop('data.financing.terms.' + $(el).parent().index());
				}
			},
			'$addLoanFee': {
				click: () => {
					$.app.post.$push('data.financing.fees', {
						//
						uid: LS.util.uid()
					});
				}
			},
			'$deleteLoanFee': {
				click: (e, el) => {
					$.app.post.$drop('data.financing.fees.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Calculate payment
	 */
	calculatePayment() {
		let price = this.data.custom ?
			this.data.price : this.root.data.price;
		let down = this.data.down;
		let rate = this.data.rate;
		let term = this.data.term;

		if (! price || down === '' || rate === '' || term === '') {
			return null;
		}

		price = LS.util.parseNumber(price);
		down = LS.util.parseNumber(down);

		if (this.data.down_type === 'percent') {
			down = price * (down / 100);
		}

		const balloon = LS.util.parseNumber(this.data.balloon || 0);
		const amount = price - down - balloon;

		rate = LS.util.parseNumber(rate);
		term = LS.util.parseNumber(term);

		if (! rate) {
			return amount / term;
		}

		const monthly = rate / 100 / 12;

		return amount * (
			(monthly * Math.pow(1 + monthly, term)) /
			(Math.pow(1 + monthly, term) - 1)
		);
	},

	/**
	 * Initialize phone
	 */
	initPhone() {
		const agents = $.app.post.$get('data.agents');

		if (agents && agents[0].id !== LS.user.get('id')) {
			return;
		}

		LS.api.get('me/profile/phone', {
			auth: true,
			flash: false,
			success: data => {
				if (! data.phone) {
					$.app.post.$set('phone', true);
				}
			}
		});
	},

	/**
	 * Populate financing
	 */
	populateFinancing() {
		const scope = this;
		const financing = $.app.post.$get('data.financing', {});

		(financing.terms || []).forEach((term, index) => {
			$.app.post.$merge(`data.financing.terms.${index}`, {
				uid: LS.util.uid(),
				custom: Boolean(term.price),
				payment: scope.calculatePayment
			});
		});

		(financing.fees || []).forEach((fee, index) => {
			$.app.post.$set(`data.financing.fees.${index}.uid`, LS.util.uid());
		});
	},

	/**
	 * Validate detail step
	 *
	 * @returns {Boolean}
	 */
	detailValidate() {
		const scope = this;
		const financePattern = new RegExp('((\\$[\\d,.]{2,}|\\d%)( ?\\S*)? (doc(ument)?|down|monthly payments?|note))|((doc(ument)?|note) fee|down( payment)?|monthly payments?)( ?\\S*)? (\\$[\\d,.]{2,}|\\d%)', 'i');

		if (scope.editor && ! scope.syndicated) {
			const html = scope.editor.html();

			let error;

			$.app.post.$set('description', html);

			if (! html) {
				error = 'Description field is required';
			} else {
				const description = scope.editor.text();

				if (description.length < 150) {
					error = 'Description must be over 150 characters';
				} else if (! LS.validate.isMixedCase(description)) {
					error = 'Description must be "Sentence case"';
				} else if (LS.validate.hasUrl(description)) {
					error = 'Description cannot contain website links';
				} else if (LS.validate.hasPhone(description)) {
					error = 'Description cannot contain phone numbers';
				} else if (LS.validate.hasEmail(description)) {
					error = 'Description cannot contain emails';
				} else {
					const price = $.app.post.$get('data.price');

					if (price && price > 1 && new RegExp('\\b' + LS.util.formatNumber(price).replace(/,/g, ',?') + '\\b').test(description)) {
						error = 'Description cannot contain the price';
					} else if (new RegExp('\\sh\.?o\.?a\.?( fees?)?( ?\S*)? \$', 'i').test(description)) {
						error = 'Description cannot contain expenses — use fields below';
					} else if (new RegExp('\\s(a\.?p\.?n\.?s?|parcel(\\(?s\\)?)?( (#|id|num(ber)?s?))?):', 'i').test(description)) {
						error = 'Description cannot contain parcels — use fields below';
					} else if (new RegExp('\\stax(es)?( ?\S*)? \$', 'i').test(description)) {
						error = 'Description cannot contain taxes — use fields below';
					}
				}

				if (! error && financePattern.test(description)) {
					error = 'Description cannot contain finance terms — use fields below';
				}
			}

			if (error) {
				LS.util.warn(error);

				LS.util.setScroll(scope.$form);

				return false;
			}

			if (! scope.id && ! scope.readable) {
				scope.readable = true;

				LS.api.post('me/listings/readable', {
					auth: true,
					flash: false,
					data: {
						description: html,
						structure: $.app.post.$get('data.structure')
					},
					success: data => {
						if (data.score && data.score < 40) {
							scope.setStep(2);

							LS.util.setScroll(scope.$form);

							LS.modal.open({
								model: {
									title: 'Description review',
									content: $.view.get('account-post.modals.readable')
								},
								width: 520
							});
						}
					}
				});
			}
		}

		scope.detailDrop();

		const parcels = $.app.post.$get('data.parcels');

		if (parcels) {
			const parcelIds = LS.util.pluck(parcels, 'parcel_number');

			if (parcelIds.some((val, i) => parcelIds.indexOf(val) !== i)) {
				LS.util.warn('Parcel numbers cannot be repeated');

				return false;
			}
		}

		const utilities = $.app.post.$get('data.utilities');

		if (utilities) {
			const utilityIds = LS.util.pluck(utilities, 'utility_id');

			if (utilityIds.some((val, i) => utilityIds.indexOf(val) !== i)) {
				LS.util.warn('Only one of each utility type is allowed');

				return false;
			}
		}

		const directions = $.app.post.$get('data.directions', '')
			.trim();

		if (directions) {
			let error;

			if (directions.length < 30) {
				error = 'Directions must be over 30 characters';
			} else if (/(https?:\/\/|www\.)([a-z\d\-.]+)\.[a-z]{2,}/i.test(directions)) {
				error = 'Directions cannot contain website links';
			} else {
				const breaks = directions.split("\n").length;

				if (
					breaks >= 10 ||
					(directions.match(/turn/ig) || []).length >= 5 ||
					(
						breaks >= 5 &&
						/((-|\d\.?) ?(take|turn)|\n[\d.]+ ?(ft|mi)|[\d.]+ ?(min|sec))/i.test(directions)
					)
				) {
					error = 'Turn-by-turn directions are not allowed';
				}
			}

			if (error) {
				LS.util.warn(error);

				LS.validate.highlight('#directions', true);

				return false;
			}
		}

		const financing = $.app.post.$get('data.financing');

		if (financing) {
			if (financing.terms && financing.terms.some(val => val.price === $.app.post.$get('data.price'))) {
				LS.util.warn('Overridden finance price cannot match listing');

				return false;
			}

			const financeDetails = financing.details

			if (financeDetails && financePattern.test(financeDetails)) {
				LS.util.warn('Financing terms must be provided as payments and fees');

				LS.validate.highlight('#financing.details', true);

				return false;
			}
		}

		return scope.validateStep();
	},

	/**
	 * Remove empty detail rows
	 */
	detailDrop() {
		this.drop([
			'expenses',
			'open_houses',
			'parcels',
			'schools',
			'taxes',
			'utilities'
		]);
	}
});